import { APIError } from './isAPIError';
import { getAPIHost } from './metaTags';

const baseURL = `${getAPIHost()}/v1/public-services`;

/**
 * Posts a request to generate a location share request URL for a given caller ID.
 * expect a url along the lines of: /assist/locationrequest?token=ABC123
 */
export const postLocationShareRequestUrl = async (
  callerID = '',
  orgName = '',
  token = '',
): Promise<string> => {
  const response = await fetch(`${baseURL}/location-share/request-url`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-RapidSOS-Org': orgName,
      Authorization: `Bearer ${token}`,
    }),
    body: JSON.stringify({ caller_id: callerID }),
  });

  if (!response.ok) {
    throw new Error(`Request Location Failed: ${response.statusText}`);
  }

  const data = await response.json();
  return data.location_request_url;
};

interface PostLocationShareLocationProps {
  token: string;
  latitude: number;
  longitude: number;
  uncertainty_radius: number;
  altitude?: number | null;
  altitude_uncertainty_radius?: number | null;
}

/**
 * Send location information for a given location share token.
 */
export const postLocationShareLocation = async ({
  token,
  latitude,
  longitude,
  uncertainty_radius,
  altitude,
  altitude_uncertainty_radius,
}: PostLocationShareLocationProps): Promise<void> => {
  const response = await fetch(
    `${baseURL}/location-share/location?token=${token}`,
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        latitude,
        longitude,
        uncertainty_radius,
        altitude,
        altitude_uncertainty_radius,
      }),
    },
  );

  if (!response.ok) {
    const error = new Error(
      `Request Location Failed: ${response.statusText}`,
    ) as APIError;
    error.status = response.status;
    throw error;
  }
};

export const getLocationShareLocation = async ({
  callerID = '',
  orgName = '',
  token = '',
}) => {
  const response = await fetch(
    `${baseURL}/location-share/location?caller_id=${callerID}`,
    {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-RapidSOS-Org': orgName,
        Authorization: `Bearer ${token}`,
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`Request Location Failed: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

export const getLocationShareValidate = async ({ token = '' }) => {
  const response = await fetch(
    `${baseURL}/location-share/validate?token=${token}`,
    {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`Request Location Failed: ${response.statusText}`);
  }

  return;
};
